/** Environment per build deployata (dev/test/preprod/prod): unica build, config OAuth da BE. */
export const env = {
  api: {
    baseUrl: '/api/mp',
    baseUrlPublic: '/api/mp/public',
    baseUrlProtected: '/api/mp/mp',
  },
  crm: {
    endpoint: '/api/crm/',
    leadForm: 'mappadelpatrimonio-contatto',
  },
  map: {
    cartoApiKey: 'cb1_2as7_1_c2b97891e38da96c37b50701',
  },
};
